import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { useSelector } from 'react-redux'
import {
    Modal,
    Button,
    MaintenanceDurationPicker,
    MM_DEFAULT_MINUTES
} from 'web/src/app/root/components/common'

const useStyles = makeStyles(theme => ({
    root: {
        maxHeight: '90vh',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column'
    },
    pageTitle: {
        marginBottom: 40
    },
    btnsWrapper: {
        marginTop: 20,
        display: 'flex',
        justifyContent: 'flex-end'
    }
}))

export const LocationConfirmMMModeOnModal = ({
    onClose,
    open,
    onConfirmClick
}) => {
    const locale = useSelector(state => state.main.locale)
    const theme = useSelector(state => state.main.theme)
    const classes = useStyles(theme)
    const [minutes, setMinutes] = useState(MM_DEFAULT_MINUTES)
    const [isDurationValid, setIsDurationValid] = useState(true)

    const onConfirm = () => {
        onConfirmClick(minutes)
        onClose()
    }

    return (
        <Modal size="md" onClose={onClose} open={open} className={classes.root}>
            <div>{locale.locations.confirmMMModeOnDescr}</div>
            <MaintenanceDurationPicker
                value={minutes}
                onChange={setMinutes}
                label={locale.common.maintenanceMode}
                onValidityChange={setIsDurationValid}
            />
            <div className={classes.btnsWrapper}>
                <Button
                    style={{ marginRight: 8 }}
                    disabled={!isDurationValid}
                    onClick={onConfirm}>
                    {locale.common.confirm}
                </Button>
                <Button reverted onClick={onClose}>
                    {locale.common.cancel}
                </Button>
            </div>
        </Modal>
    )
}
